import React from "react";
const FormBuilderFormInterfaceSuccessMessage = ({ item, t }) => {
  var _a, _b;
  if (!item) return null;
  const successMessageData = item.elements;
  return /* @__PURE__ */ React.createElement("output", { className: item.class }, /* @__PURE__ */ React.createElement("span", null, t((_a = successMessageData == null ? void 0 : successMessageData.find((el) => el.nodeName === "h2")) == null ? void 0 : _a.nodeValue)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, t((_b = successMessageData == null ? void 0 : successMessageData.find((el) => el.nodeName === "p")) == null ? void 0 : _b.nodeValue))));
};
export default FormBuilderFormInterfaceSuccessMessage;
